import * as S from './styles';

import CloseIcon from '@svgIcons/close.svg';

import { isValueExist } from '@/utils/utils';

const valuePath = R.path(['target', 'value']);

export default {
    name: 'MultiInputField',
    props: {
        values: {
            type: Array,
            default: [],
        },
        placeholder: String,
        autofocus: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        autocorrect: {
            type: String,
            default: 'on',
        },
        autocapitalize: {
            type: String,
            default: 'none',
        },
        inputType: {
            type: String,
            default: 'text',
        },
    },
    watch: {
        values: {
            handler(newValue, oldValue) {
                // reset _value
                if (newValue.length > oldValue.length) {
                    this._value = '';
                }
            },
        },
    },
    data() {
        return {
            _value: '',
        };
    },
    render() {
        const {
            placeholder = '',
            className = '',
            autofocus,
            disabled,
            autocorrect,
            autocapitalize,
            inputType,
            values,
        } = this;

        let props = {
            attrs: {
                class: className,
                placeholder: isValueExist(values) ? '' : placeholder,
                autofocus,
                disabled,
                autocorrect,
                autocapitalize,
                type: inputType,
            },
            ref: 'inputElem',
            on: {
                keydown: (e) => this.$emit('keydown', e),
                keyup: (e) => this.$emit('keyup', e),
                change: (e) => this.$emit('change', e),
                click: (e) => this.$emit('click', e),
                input: (e) => this.$emit('input', e),
                blur: (e) => this.$emit('blur', e),
                paste: (e) => this.$emit('paste', e),
                compositionstart: (e) => this.$emit('compositionstart', e),
                compositionend: (e) => this.$emit('compositionend', e),
            },
        };

        return (
            <S.Wrapper
                onClick={() => {
                    const inputElem = this.$refs.inputElem;
                    inputElem && inputElem.focus();
                }}
            >
                {values.map((value, idx) => {
                    return (
                        <S.TagItem>
                            {this.wrapTooltip({
                                visible: true,
                                content: (
                                    <S.TagText class="adriel-ellipsis">
                                        {value}
                                    </S.TagText>
                                ),
                                title: value,
                            })}
                            <CloseIcon
                                class="s-close"
                                v-view-box
                                onClick={() => this.$emit('deleteIdx', idx)}
                            />
                        </S.TagItem>
                    );
                })}
                <input
                    {...props}
                    value={this._value}
                    onInput={(e) => (this._value = valuePath(e))}
                />
            </S.Wrapper>
        );
    },
};
